import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

const container = document.getElementById('root');

const aplicacao = (
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// O build gera HTML estático para cada rota (scripts/prerender.js). Quando ele
// existe, hidratamos em vez de renderizar do zero: a página já aparece pronta
// e o React apenas assume o controle dela.
if (container.hasChildNodes()) {
  hydrateRoot(container, aplicacao);
} else {
  createRoot(container).render(aplicacao);
}
